import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DisplayInboundAppChatComponent } from './display-inbound-app-chat.component';

const routes: Routes = [
  {
    path: '',
    component: DisplayInboundAppChatComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DisplayInboundAppChatRoutingModule {}
